/**
 * DefaultStream entity class
 */
import { SECURITY_LEVEL_TYPES } from '../../../app/core/constants'

/**
 * DefaultStreamFactory
 * returns DefaultStream entity class
 *
 * @class DefaultStreamFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DefaultStream} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DefaultStreamFactory
 */
/* @ngInject */

export default function DefaultStreamFactory (Entity) {
  /* === DefaultStream class === */

  /**
   * DefaultStream model
   *
   * @class DefaultStream
   * @classdesc DefaultStream model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.DefaultStream} DefaultStream entity
   */
  function DefaultStream () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DefaultStream.prototype = Object.create(Entity.prototype)
  DefaultStream.prototype.constructor = DefaultStream

  /* === DefaultStream instance methods & fields === */

  Object.assign(DefaultStream.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DefaultStream#
     * @type {Object}
     */
    _fields: {
      id: String,
      playbackUrl: String,
      source: String,
      trailerUrl: String,
      mediaUrl: {
        id: Number,
        mediaUrl: String,
        playbackTokenGeneratorId: Number,
        trailerUrl: String,
        contentId: String,
        kek: String,
        entitlementPolicyId: String,
        bundleId: String,
        drmProfiles: [{
          id: Number,
          drmAccountId: Number,
          name: String,
          enabled: true,
          callbackUrl: String,
          drmType: String,
          fpsCertificate: String,
          fpsCertificateFileName: String,
          hardwareDrmRequired: Boolean,
          hdcpType: 'NO_HDCP',
          integrationType: 'TOKEN',
          licenseDurationSec: 0,
          rentalDurationSec: 0,
          outputProtectionLevel: 0,
          persistentLicense: false,
          playReadySecurityLevel: Object.keys(SECURITY_LEVEL_TYPES)[0],
          providerType: String,
          robustnessLevel: 'SW_SECURE_CRYPTO',
          rootedDeviceAllowed: Boolean,
          keyStorageUrl: String,
          tokenRequestUrl: String
        }]
      },
      $tokenGeneratorType: String
    },

    /**
     * Prepare DefaultStream
     *
     * @memberof models.DefaultStream#
     * @override
     */
    _prepare: function () {
      if (!this.id) {
        this.mediaUrl = { drmProfiles: [] }
      }
    }
  })

  /* === DefaultStream static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DefaultStream, Entity)
  DefaultStream._name = 'DefaultStream'
  DefaultStream.init()

  return DefaultStream
}
